import { render, staticRenderFns } from "./shenqing.vue?vue&type=template&id=67ea1c8f&scoped=true&"
import script from "./shenqing.vue?vue&type=script&lang=js&"
export * from "./shenqing.vue?vue&type=script&lang=js&"
import style0 from "./shenqing.vue?vue&type=style&index=0&id=67ea1c8f&lang=scss&scoped=true&"
import style1 from "./shenqing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ea1c8f",
  null
  
)

export default component.exports